module.exports = __webpack_public_path__ + "static/media/symbol-omnyve.b58b6df4.svg";